import {Directive, forwardRef, inject, input} from '@angular/core';
import {AbstractControl, AsyncValidator, NG_ASYNC_VALIDATORS, ValidationErrors} from '@angular/forms';
import {map, Observable, of} from 'rxjs';
import {MasterProcessedOtherRest} from '../../service/MasterProcessedOtherRest';

@Directive({
  selector: '[existCodeMasterProcessedOther]',
  standalone: true,
  providers: [{provide: NG_ASYNC_VALIDATORS, useExisting: forwardRef(() => ExistCodeDirective), multi: true}]
})
export class ExistCodeDirective implements AsyncValidator {
  rest = inject(MasterProcessedOtherRest)
  itemId = input.required<number>()

  validate(control: AbstractControl): Promise<ValidationErrors | null> | Observable<ValidationErrors | null> {
    if (!control.value) {
      return of(null);
    }
    return this.rest.existCode(control.value,this.itemId()).pipe(map(e => {
      if (!e) {
        return null
      } else {
        return {exists: 'exist'}
      }
    }))
  }
}
